module.exports = __webpack_public_path__ + "img/6.5c464a2d.jpg";